<template>
  <div class="bundle-home-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Bundle Home Section -->
    <section class="bundle-home-section">
      <div class="container">
        <div class="bundle-content">
          <div class="bundle-title">
            <h1>Bundle Home and Auto and save up to 20%</h1>
          </div>
          
          <div class="bundle-options">
            <button 
              :class="['bundle-btn', { 'selected': selectedOption === 'bundle' }]"
              @click="selectOption('bundle')"
            >
              Bundle!
            </button>
            <button 
              :class="['bundle-btn', { 'selected': selectedOption === 'no-thanks' }]"
              @click="selectOption('no-thanks')"
            >
              No Thank You
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'BundleHomePage',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      userQuoteData: null,
      selectedOption: null
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 检查是否有房屋所有权信息且选择了own
          if (!this.userQuoteData.home_ownership || this.userQuoteData.home_ownership !== 'own') {
            // 如果没有选择own，跳转回home-ownership页面
            this.$router.push('/home-ownership')
            return
          }
          // 加载之前选择的选项（如果有的话）
          if (this.userQuoteData.bundle_home !== undefined) {
            this.selectedOption = this.userQuoteData.bundle_home
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    async selectOption(option) {
      this.selectedOption = option
      
      // 更新用户数据
      this.userQuoteData.bundle_home = option
      this.saveUserData()
      
      console.log('Selected bundle option:', option)
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('bundlehome')
      // 无论选择什么，都跳转到Email Address页面
      this.$router.push('/email-address')
    },
    
    goBack() {
      this.$router.push('/home-ownership')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.bundle-home-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Bundle Home Section */
.bundle-home-section {
  padding: 4rem 0;
  background: #fff;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bundle-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
}

.bundle-title h1 {
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 3rem;
  line-height: 1.3;
}

.bundle-options {
  display: flex;
  gap: 2rem;
  justify-content: center;
}

.bundle-btn {
  padding: 1.5rem 3rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 180px;
}

.bundle-btn:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.bundle-btn.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .bundle-content {
    padding: 0 1rem;
  }

  .bundle-title h1 {
    font-size: 1.6rem;
    margin-bottom: 2rem;
  }

  .bundle-options {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }

  .bundle-btn {
    width: 100%;
    max-width: 300px;
    padding: 1.2rem 2rem;
    font-size: 1.1rem;
    min-width: unset;
  }
}

@media (max-width: 480px) {
  .bundle-content {
    padding: 0 0.5rem;
  }

  .bundle-title h1 {
    font-size: 1.4rem;
  }

  .bundle-btn {
    padding: 1rem 1.5rem;
    font-size: 1rem;
  }

  .bundle-options {
    gap: 1rem;
  }
}
</style>
